import { createSelector } from 'reselect';
import { getTrendKPIsList } from '../TrendKPIList/selectors';
import { getEnergyRelatedKPIsList } from '../EnergyRelatedSignalsList/selectors';
import { createErrorDataSelector } from 'selectors/selectorUtils';

const getCommentsDrawerVisible = ({ operationalParameters }) => {
    return operationalParameters?.isTrendCommentsDrawerVisible;
};

const getUser = ({ overview }) => {
    return overview?.user?.data;
};

const getCommentsModalVisible = ({ operationalParameters }) => {
    return operationalParameters?.isTrendCommentsModalVisible;
};

export const getDateSelection = ({ overview }) => {
    return overview?.dateSelection;
};

const getCommentsList = ({ operationalParameters }) => {
    return operationalParameters?.trendCommentsList?.data;
};

const getCommentsListLoaderStatus = ({ operationalParameters }) => {
    return operationalParameters?.trendCommentsList?.loadingStatus;
};

export const getSelectedTrendKPIs = ({ operationalParameters }) => {
    return operationalParameters?.preselectedKPIs?.single?.trend;
};

export const getSelectedAsset = ({ powertrainAssetDetails }) => {
    return powertrainAssetDetails.selectedAsset;
};

const getTrendCommentsCreateEditLoadingStatus = ({ operationalParameters }) => {
    return operationalParameters?.trendCommentsCreateEditLoadingStatus;
};

const getTrendCommentsCreateEditRawError = ({ operationalParameters }) => {
    return {
        loadingStatus: operationalParameters?.trendCommentsCreateEditLoadingStatus,
        error: operationalParameters?.trendCommentsCreateEditError,
        errorCode: operationalParameters?.trendCommentsCreateEditError?.statusCode
    };
};

const getTrendCommentsCreateEditErrorData = createErrorDataSelector(getTrendCommentsCreateEditRawError);

const getTrendCommentsDeleteLoadingStatus = ({ operationalParameters }) => {
    return operationalParameters?.trendCommentsDeleteLoadingStatus;
};

const getTrendCommentsDeleteRawError = ({ operationalParameters }) => {
    return {
        loadingStatus: operationalParameters?.trendCommentsDeleteLoadingStatus,
        error: operationalParameters?.trendCommentsDeleteError,
        errorCode: operationalParameters?.trendCommentsDeleteError?.statusCode
    };
};

const getTrendCommentsDeleteErrorData = createErrorDataSelector(getTrendCommentsDeleteRawError);

const getEditCommentData = ({ operationalParameters }) => {
    return operationalParameters?.editCommentData;
};

const getGraphCommentTimestamp = ({ operationalParameters }) => {
    return operationalParameters?.graphCommentTimestamp;
};

const getSelectedTrendCommentsList = ({ operationalParameters }) => {
    return operationalParameters?.selectedTrendCommentsList;
};

const getSelectedDataPointTimestamp = ({ operationalParameters }) => {
    return operationalParameters?.selectedDataPointTimestamp;
};

export const getModel = createSelector([
    getCommentsDrawerVisible,
    getCommentsModalVisible,
    getDateSelection,
    getCommentsList,
    getSelectedTrendKPIs,
    getSelectedAsset,
    getTrendCommentsCreateEditLoadingStatus,
    getTrendCommentsDeleteLoadingStatus,
    getEditCommentData,
    getTrendKPIsList,
    getCommentsListLoaderStatus,
    getGraphCommentTimestamp,
    getSelectedTrendCommentsList,
    getSelectedDataPointTimestamp,
    getEnergyRelatedKPIsList,
    getUser,
    getTrendCommentsCreateEditErrorData,
    getTrendCommentsDeleteErrorData
], (
    isTrendCommentsDrawerVisible,
    isTrendCommentsModalVisible,
    dateSelection,
    trendCommentsList,
    selectedTrendKPIs,
    selectedAsset,
    trendCommentsCreateEditLoadingStatus,
    trendCommentsDeleteLoadingStatus,
    editCommentData,
    trendKPIsList,
    trendCommentsListLoadingStatus,
    graphCommentTimestamp,
    selectedTrendCommentsList,
    selectedDataPointTimestamp,
    energyRelatedKPIsList,
    user,
    trendCommentsCreateEditErrorData,
    trendCommentsDeleteErrorData
) => {
    return {
        isTrendCommentsDrawerVisible,
        isTrendCommentsModalVisible,
        dateSelection,
        trendCommentsList,
        selectedTrendKPIs,
        selectedAsset,
        trendCommentsCreateEditLoadingStatus,
        trendCommentsDeleteLoadingStatus,
        editCommentData,
        trendKPIsList,
        trendCommentsListLoadingStatus,
        graphCommentTimestamp,
        selectedTrendCommentsList,
        selectedDataPointTimestamp,
        energyRelatedKPIsList,
        user,
        trendCommentsCreateEditErrorData,
        trendCommentsDeleteErrorData
    };
});
